

export const OneDayPresentation = () => {
  const tours = ['Antigua', 'Lago', 'City', 'Pacaya', 'Tikal',];
  return (
    <div className="one-day-tour-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/oneDayTours/${tour}.jpg`} className={`one-day-tour-presentation-img`} alt={tour} key={`${i}-One-Day-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
